import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { useForm } from "react-hook-form";
import { Paper, Typography, RadioGroup } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import BaseApi from "../../../../functions/axios";
import ChangeUserInfoButton from "../molecules/AdminChangeUserInfoButton";
import "../../../../style/disabledRadioButton.css";

const schema = yup.object({
  name: yup
    .string()
    .required("名前を入力してください")
    .min(2, "正しい名前を入力してください"),
  mailAdress2: yup
    .string()
    .notRequired()
    .matches(
      /^.{0}$|^[a-zA-Z0-9_.+-]+@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,4}$/,
      "有効なメールアドレスを入力してください"
    ),
});

export default function AdminChangeUserInfoForm() {
  const [mailNotification, setMailNotification] = useState(0);
  const [userClass, setUserClass] = useState(Number(process.env.REACT_APP_GENERAL_CLASS));
  const [data, setData] = useState(null);
  const [nameCheck, setNameCheck] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const userId = location.state?.user?.id;

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const handleChangeMailNotification = (e) => setMailNotification(Number(e.target.value));
  const handleChangeUserClass = (e) => setUserClass(Number(e.target.value));

  useEffect(() => {
    if (userId) {
      BaseApi.get("user", { params: { user_id: userId } }).then((result) => {
        const userData = result.data.data;
        setData(userData);
        setNameCheck(userData.name);
        setUserClass(userData.admin_flag);
        setMailNotification(userData.notification_flag);
        // React Hook Form に初期値をセット
        reset({ name: userData.name });
      });
    }
  }, [userId, reset]);

  if (!data) return null;

  const onSubmit = (event) => {
    const postData = {
      user_id: userId,
      name: event.name,
      admin_flag: userClass,
      notification_flag: mailNotification,
    };
    BaseApi.post("update_user", postData).then(() => {
      navigate("/adminManagement");
    });
  };

  return (
    <Box component="form" onSubmit={handleSubmit(onSubmit)} noValidate>
      <Paper elevation={0}>
        <Grid container alignItems="center" sx={{ borderBottom: 1, borderColor: "#F2F3F4" }}>
          <Grid item xs={4} sm={2.5} paddingLeft="20px" paddingY="20px" sx={{ fontWeight: "bold" }}>
            氏名
          </Grid>
          <Grid item xs={8} sm={9.5} paddingY="20px" sx={{ paddingLeft: "15px" }}>
            <TextField
              variant="standard"
              required
              type="text"
              {...register("name", {
                onChange: (e) => setNameCheck(e.target.value),
              })}
              error={!!errors.name}
              helperText={errors.name?.message}
              fullWidth
              id="name"
              InputProps={{ disableUnderline: true, style: { fontSize: 16 } }}
            />
          </Grid>
        </Grid>
      </Paper>

      <Paper elevation={0}>
        <Grid container alignItems="center" sx={{ borderBottom: 1, borderColor: "#F2F3F4" }}>
          <Grid item xs={4} sm={2.5} paddingLeft="20px" paddingY="20px" sx={{ fontWeight: "bold" }}>
            メールアドレス
          </Grid>
          <Grid item xs={8} sm={9.5} sx={{ paddingY: "20px", fontSize: 16, paddingLeft: "15px" }}>
            {data.email}
          </Grid>
        </Grid>
      </Paper>

      <Paper elevation={0} sx={{ borderBottom: 1, borderColor: "#F2F3F4" }}>
        <Grid container alignItems="center">
          <Grid item xs={4} sm={2.5} paddingLeft="20px" paddingY="20px" sx={{ fontWeight: "bold" }}>
            ユーザ区分
          </Grid>
          <Grid item xs={8} sm={9.5} sx={{ mt: "20px", mb: "20px", fontSize: 16, paddingLeft: "15px" }}>
            <RadioGroup value={userClass} row onChange={handleChangeUserClass}>
              <FormControlLabel
                value={Number(process.env.REACT_APP_BP_MANAGEMENT_CLASS)}
                label={<Typography fontSize={16}>BP管理者</Typography>}
                disabled={userId === Number(localStorage.getItem("userId"))}
                control={<Radio size="small" sx={{ "&.Mui-checked": { color: "#28345E" } }} />}
              />
              <FormControlLabel
                value={Number(process.env.REACT_APP_GENERAL_CLASS)}
                label={<Typography fontSize={16} color={userId === Number(localStorage.getItem("userId")) ? "#808080" : "inherit"}>一般ユーザ</Typography>}
                disabled={userId === Number(localStorage.getItem("userId"))}
                control={<Radio size="small" sx={{ "&.Mui-checked": { color: "#28345E" } }} />}
              />
            </RadioGroup>
          </Grid>
        </Grid>
      </Paper>

      <Paper elevation={0}>
        <Grid container alignItems="center" sx={{ borderBottom: 1, borderColor: "#F2F3F4" }}>
          <Grid item xs={4} sm={2.5} paddingLeft="20px" paddingY="20px" sx={{ fontWeight: "bold" }}>
            新着マッチング
          </Grid>
          <Grid item xs={8} sm={9.5} sx={{ mt: "20px", mb: "20px", fontSize: 16, paddingLeft: "15px" }}>
            <RadioGroup value={mailNotification} row onChange={handleChangeMailNotification}>
              <FormControlLabel
                value={1}
                label={<Typography fontSize={16}>通知する</Typography>}
                control={<Radio size="small" sx={{ "&.Mui-checked": { color: "#28345E" } }} />}
              />
              <FormControlLabel
                value={0}
                label={<Typography fontSize={16}>通知しない</Typography>}
                control={<Radio size="small" sx={{ "&.Mui-checked": { color: "#28345E" } }} />}
              />
            </RadioGroup>
          </Grid>
        </Grid>
      </Paper>
      <ChangeUserInfoButton
        mailNotification={mailNotification}
        userClass={userClass}
        nameCheck={nameCheck}
        data={data}
      />
    </Box>
  );
}